import Dropdown from './Dropdown';
import GlobeIcon from '../../assets/icons/globe.svg';

interface LanguageSelectorProps {
    el: HTMLElement;
}

// Build on top of dropdown component
const LanguageSelector = ({ el }: LanguageSelectorProps): void => {
    const choices = Dropdown({ el, props: { prefixIcon: GlobeIcon, ariaLabel: 'select language' } });

    if (!choices?.config.choices.length) {
        return;
    }

    el.addEventListener('change', e => {
        const { value } = (e as CustomEvent).detail;

        if (!value) {
            return;
        }

        window.location.href = value;
    });
};

export default LanguageSelector;

